import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class ExternalAccountService {

  constructor(private http: HttpClient) {}
  
  getExternalIds(id: number,type:string): Observable<any> {
    const requestUrl : string = `${environment.backendUrl}/api/${type}/${id}/external_ids`;
    
    return this.http.get<any>(requestUrl);
  }
}
